import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import stars from '@/components/beidou'
import aboutUs from '@/components/aboutUs'
import supplyChain from '@/components/supply'
import logistics from '@/components/logistics'
import shipData from '@/components/shipData'
import shipManage from '@/components/shipManage'
import dataApi from "../components/dataApi";
import trade from '@/components/trade'
import finance from '@/components/finance'
import fleet from '@/components/fleet'
import news from '@/components/news'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        keepAlive: false, // 不需要缓存
        title:'首页'
      }
    },
    {
      path: '/stars',
      name: 'stars',
      component: stars,
      meta: {
        keepAlive: false, // 不需要缓存

      }

    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/supplyChain',
      name: 'supplyChain',
      component: supplyChain,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/logistics',
      name: 'logistics',
      component: logistics,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/shipData',
      name: 'shipData',
      component: shipData,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/shipManage',
      name: 'shipManage',
      component: shipManage,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/dataAPi',
      name: 'dataAPi',
      component: dataApi,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/trade',
      name: 'trade',
      component: trade,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/finance',
      name: 'finance',
      component: finance,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/fleet',
      name: 'fleet',
      component: fleet,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        keepAlive: false, // 不需要缓存

      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js